import { DomReady } from 'tools/domready';
import { replaceState } from 'tools/replaceState';
import { smoothScrollTo } from 'tools/smoothScrollTo';
import 'pages/contact/contactMap';

// Check if hash is set
if (window.location.hash) {
    // if found, display it
    const hash = window.location.hash.substring(1);
    const element = document.querySelector(`#${ hash }`);
    toggleClasses(element);
    // Scroll to the element
    const offset = element.getBoundingClientRect().top + window.pageYOffset;
    DomReady(() => {
        setTimeout(() => {
            smoothScrollTo({ behavior: 'smooth', top: offset - 40 });
        }, 1);
    });
}

const accordionTitles = document.querySelectorAll('.accord > ul > li > a');
if (accordionTitles.length) {
    accordionTitles.forEach(accordionTitle => {
        accordionTitle.addEventListener('click', event => {
            event.preventDefault();
            const currentHash = event.currentTarget.getAttribute('href').substring(1);

            toggleClasses(event.currentTarget.parentElement);
            if (event.currentTarget.parentElement.classList.contains('active')) {
                replaceState(currentHash);
            }
        });
    });
}

function toggleClasses(element) {
    if (element && element.closest('.accord')) {
        const arrow = element.querySelector('span.arrow');
        const div = element.querySelector('div');
        element.classList.contains('active') ? element.classList.remove('active') : element.classList.add('active');
        if (arrow) {
            arrow.classList.contains('arr-right') ? arrow.classList.remove('arr-right') : arrow.classList.add('arr-right');
            arrow.classList.contains('arr-down') ? arrow.classList.remove('arr-down') : arrow.classList.add('arr-down');
        }
        if (div) {
            div.classList.contains('target') ? div.classList.remove('target') : div.classList.add('target');
            div.classList.contains('hide') ? div.classList.remove('hide') : div.classList.add('hide');
        }
    }
}
